import { EmbeddedAppVersionInfoService, NakiBoltBetaChannelService } from "common/services";
import AppReleaseRouteStore from "./AppReleaseRouteStore";

class EmbeddedAppReleaseRouteStore extends AppReleaseRouteStore {
    constructor(rootStore) {
        super(rootStore, EmbeddedAppVersionInfoService, NakiBoltBetaChannelService);
    }
}

export default EmbeddedAppReleaseRouteStore;
